import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
// member
export function memberAjaxTable(limit,pagination,master_id,created_at,username,affiliate_id,trader,old_leader,old_leader_id,status,account_job,member){
	const data = request({
		url: config.url+'user_list/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&master_id=' + master_id + '&created_at=' + created_at + '&login=' + username + '&affiliate_id=' + affiliate_id + '&trader=' + trader + '&old_leader=' + old_leader + '&old_leader_id=' + old_leader_id + '&status=' + status + '&account_job=' + account_job + '&member=' + member,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function memberInfo(master_id){
	const data = request({
		url: config.url+'user_list/info?language='+language+'&master_id=' + master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getMemberEdit(master_id){
	const data = request({
		url: config.url+'user_list/edit?language='+language+'&master_id=' + master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function memberEdit(postData){
	const data = request({
		url: config.url+'user_list/edit',
		method: 'post',
		data: postData
	});

	return Promise.resolve(data);
}

export function getPermissionMember(master_id){
	const data = request({
		url: config.url+'user_list/permission?master_id='+master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function permissionMember(postData){
	const data = request({
		url: config.url+'user_list/permission',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function memberExport(date){
	const data = request({
		url: config.url+'user_list/export_user_list?date='+date,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getMemberBadge(master_id){
	const data = request({
		url: config.url+'user_list/badge?master_id='+master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeMember(postData){
	const data = request({
		url: config.url+'user_list/badge',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function memberLog(master_id,limit,pagination){
	const data = request({
		url: config.url+'user_list/memberLog?language='+language+'&master_id=' + master_id +'&limit=' + limit + '&pagination=' + pagination,
		method: 'get'
	});

	return Promise.resolve(data);
}

// profile
export function profileAjaxTable(){
	const data = request({
		url: config.url+'profile',
		method: 'get'
	});

	return Promise.resolve(data);
}

export function profileEdit(postData){
	const data = request({
		url: config.url+'profile',
		method: 'post',
		data: postData
	});

	return Promise.resolve(data);
}

// special
export function specialAjaxTable(limit,pagination,id,login,status_id,created_at){
	const data = request({
		url: config.url+'special/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&login=' + login + '&status_id=' + status_id + '&created_at=' + created_at,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function specialAdd(postData){
	const data = request({
		url: config.url+'special/add',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function getSpecialEdit(id){
	const data = request({
		url: config.url+'special/edit?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function specialDelete(postData){
	const data = request({
		url: config.url+'special/delete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function specialEdit(postData){
	const data = request({
		url: config.url+'special/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function locationReset(postData){
	const data = request({
		url: config.url+'user_list/resetlastlogin',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// device binding
export function deviceBindingAjaxTable(limit,pagination,id,created_at,master_id,device_model,imei){
	const data = request({
		url: config.url+'account_device/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&master_id=' + master_id + '&device_model=' + device_model + '&imei=' + imei,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function deviceBindingAdd(postData){
	const data = request({
		url: config.url+'account_device/add',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function deviceBindingDelete(postData){
	const data = request({
		url: config.url+'account_device/delete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// block ip
export function blockIpAjaxTable(limit,pagination,id,created_at,ip,remark){
	const data = request({
		url: config.url+'ip_block/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&ip=' + ip + '&remark=' + remark,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function blockIpAdd(postData){
	const data = request({
		url: config.url+'ip_block/add',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function blockIpDelete(postData){
	const data = request({
		url: config.url+'ip_block/delete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}